import {getCurrentAccount, getHost} from "@/hooks/fnHelper";
import {useCookies} from "vue3-cookies";
import {getUserDataFromAccount, svodApi} from "@/api/svodApi";
import {skiPassApi} from "@/api/skiPassApi";
import deleteNonValidCookie from "@/hooks/deleteNonValidCookie";
import {usePromo} from "@/hooks/usePromo";

export const initAppPlugin = async (app) => {
    const {cookies} = useCookies();

    deleteNonValidCookie();

    const urlParams = new URLSearchParams(window.location.search);

    const getServerSid = async (tries = 0) => {
        const host = getHost();
        console.log('getServerSid host', host);

        if (urlParams.get('xuid') && cookies.isKey("gazprom_sid") && cookies.get("gazprom_sid") === urlParams.get('xuid')) {
            cookies.set('server_sid', urlParams.get('xuid'), null, null, host);
            cookies.remove('gazprom_sid', null, host);
        }

        try {
            const {data: apiData} = await svodApi.get('/lk?scope=lk+systems+auth+gp_cards');
            // console.log('apiData', apiData)
            if (!apiData?.mrktid) {
                throw new Error('No sid');
            }

            let userData = getUserDataFromAccount(apiData);
            // console.log('userData', userData,app, app._context)
            app.config.globalProperties.$userAccounts = apiData.xAccounts;

            if (userData) {
                app.config.globalProperties.$user = userData;
            }

            console.log('apiData.mrktid', apiData.mrktid)
            console.log('apiData.current_XAccountUId', apiData.current_XAccountUId)

            cookies.set('server_sid', apiData.mrktid, '365d', null, host);
            cookies.set('xaccountuid', apiData.current_XAccountUId, '365d', null, host);

            svodApi.defaults.headers.mrktsid = apiData.mrktid;
            svodApi.defaults.headers.xaccountuid = apiData.current_XAccountUId;
            skiPassApi.defaults.headers.mrktsid = apiData.mrktid;
            skiPassApi.defaults.headers.xaccountuid = apiData.current_XAccountUId;

            let currentAccount = getCurrentAccount(apiData.xAccounts, apiData.mrktid);

            if(currentAccount){
                app.config.globalProperties.$currentAccount = currentAccount;
            }
            // await delay(250);
        } catch (e) {
            if (tries < 0) {
                return await getServerSid(++tries);
            }
        }
    }

    const getServerRoutes = async (tries = 0) => {
        try {
            const {data: serverRouters} = await svodApi.get('/salegroups?t=all', {
                timeout: 35000
            });

            app.config.globalProperties.$serverRouters = serverRouters;
        } catch (e) {
            if (tries < 0) {
                return await getServerRoutes(++tries);
            }
            throw e;
        }
    }

    const delay = async (ms) => await new Promise(resolve => setTimeout(resolve, ms));

    await getServerSid();

    if (urlParams.get('xpromo')) {
        console.log('xpromo', )
        try {
            await usePromo().add(urlParams.get('xpromo'));
            getServerSid();
        } catch (e){}
    }

    await getServerRoutes();
}